// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6d4a3ffe","667":"1adf64fa"}[chunkId] + ".chunk.js";
};